/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var sm = "2px";
export var md = "4px";
export var lg = "8px";
export var xl = "16px";
export var circle = "50%";
//# sourceMappingURL=border-radius.js.map